// extracted by mini-css-extract-plugin
export default {"listItem":"qY_KdZIyGy","unfavorIcon":"x80qTuB0vy"};